import React, { ChangeEvent } from "react";

import { Icon, IconProps } from "@cobasi/ds-icons";

import styles from "./styles.module.scss";
import classNames from "classnames";

interface Option {
  value: string | number;
  label: string;
}

interface CustomSelectProps {
  options: Option[];
  placeholder: string;
  // eslint-disable-next-line no-unused-vars
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  value: string | number;
  icon: IconProps["icon"];
  className?: string;
  disabled?: boolean;
  id?: string;
  name?: string;
  autoComplete?: string;
  label?: string;
}

const CustomSelect: React.FC<CustomSelectProps> = ({
  options,
  placeholder,
  onChange,
  value,
  icon,
  className,
  disabled,
  id,
  name,
  autoComplete,
  label
}) => {
  return (
    <div className={classNames(styles["select-container"], className)}>
      {label && (
        <label htmlFor={id} className={styles.label}>
          {label}
        </label>
      )}
      <select
        id={id}
        name={name}
        autoComplete={autoComplete}
        className={classNames(styles.select, className)}
        value={value}
        onChange={onChange}
        disabled={!!disabled}
        aria-label={label ? undefined : placeholder}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <div className={styles["icon-container"]}>
        <Icon
          icon={icon}
          width="1.2rem"
          height="1.2rem"
          color="var(--token-colors-neutral-lnk-light)"
        />
      </div>
    </div>
  );
};

export default CustomSelect;
